export function getParams(state) {
	return state.params
}


// WEBPACK FOOTER //
// ./src/modules/schedule/getters.js